import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import MetaTags from '../components/MetaTags';
import { getBreadcrumbSchema } from '../utils/schemaGenerator';
import { useTheme } from '../context/ThemeContext';

const BlogPage = () => {
  const { theme } = useTheme();
  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Blog', url: '/blog' }
  ]);

  return (
    <>
      <MetaTags
        title="Acting Tips, Audition Guides & Industry Insights | BookMyAudition Blog"
        description="Read acting tips, audition guides, portfolio advice, and casting secrets to build your acting career in Bollywood, TV serials, and web series."
        keywords="how to find acting auditions, how to prepare for an acting audition, how to give an audition, how to get auditions in Bollywood, how to become an actor in India, how to create an actor portfolio, acting audition tips, audition preparation tips, casting call meaning"
        canonical="https://web.bookmyaudition.com/blog"
        schema={breadcrumbSchema}
      />
      <div 
        className="blog-page" 
        style={{ 
          minHeight: '70vh', 
          padding: '60px 0',
          backgroundColor: theme === 'dark' ? '#0a0a14' : '#f8fafc',
          color: theme === 'dark' ? '#f8fafc' : '#111'
        }}
      >
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <h1 className="fw-bold mb-4" style={{ color: theme === 'dark' ? '#fff' : '#111' }}>
                Our Blog
              </h1>
              <p style={{ color: theme === 'dark' ? '#cbd5e1' : '#475569', fontSize: '1.1rem' }}>
                Get the latest tips on auditioning, industry insights, and acting guides written by professionals to help you grow.
              </p>
              
              <div 
                className="coming-soon-box mt-5 p-5 rounded-4 shadow-sm"
                style={{
                  backgroundColor: theme === 'dark' ? '#111116' : '#fff',
                  border: `1px solid ${theme === 'dark' ? '#1f1f2e' : '#eaeaea'}`
                }}
              >
                <div 
                  className="badge px-3 py-2 rounded-pill mb-3" 
                  style={{ backgroundColor: 'rgba(230, 57, 70, 0.15)', color: '#e63946', fontSize: '0.9rem', fontWeight: 600 }}
                >
                  📖 ARTICLES COMING SOON
                </div>
                <h3 className="fw-bold mb-3">Audition Guides & Tips</h3>
                <p className="text-muted">
                  We are preparing expert articles on audition preparation, headshot tips, self-tape etiquette, and how to crack Bollywood casting calls.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default BlogPage;